/**
 * Offre de l'organisateur d'un défi privé (paywall 0728-0729) : gratuit = 1 défi par jour
 * et 3 joueurs ; accès complet (abonnement, pass, ou toutes les SKILLCARDS du défi
 * achetées) = 50 joueurs, défis illimités.
 * Sur le web, l'organisateur gratuit peut passer à l'accès complet sans quitter la page.
 */

import { useState } from 'react';
import { Crown, Users } from 'lucide-react';
import { cn } from '@jeraisonne/ui';
import { SubscriptionAlternative } from '@/features/skillcards/skillcard-offers-panel';
import { usesStoreBilling } from '@/lib/skillcards/iap';
import {
  PRIVATE_LIVE_PREMIUM_MAX_PLAYERS,
  quotaLine,
  type PrivateLiveQuota,
} from '@/lib/private-live';

export function PrivateLivePlan({
  quota,
  returnTo = '/live/prive/nouveau',
}: {
  quota: PrivateLiveQuota;
  returnTo?: string;
}) {
  const [open, setOpen] = useState(!quota.can_create);
  const blocked = !quota.can_create;
  return (
    <div
      data-testid="private-live-plan"
      className={cn(
        'mb-4 rounded-2xl border p-3',
        quota.premium
          ? 'border-accent-300 bg-accent-50'
          : blocked
            ? 'border-warning-300 bg-warning-50'
            : 'border-ink-200 bg-white',
      )}
    >
      <p className="text-ink-900 flex items-start gap-2 text-sm font-semibold">
        {quota.premium ? (
          <Crown className="text-accent-500 mt-0.5 h-4 w-4 shrink-0" aria-hidden />
        ) : (
          <Users className="text-primary-500 mt-0.5 h-4 w-4 shrink-0" aria-hidden />
        )}
        <span>{quotaLine(quota)}</span>
      </p>
      {!quota.premium && (
        <>
          <p className="text-ink-600 mt-1 text-[13px]">
            Avec l’accès complet, ou les SKILLCARDS du défi achetées : jusqu’à{' '}
            {PRIVATE_LIVE_PREMIUM_MAX_PLAYERS} joueurs et des défis illimités.
          </p>
          {!usesStoreBilling() &&
            (open ? (
              <div className="mt-2">
                <SubscriptionAlternative signedIn returnTo={returnTo} />
              </div>
            ) : (
              <button
                type="button"
                className="text-primary-600 mt-1 min-h-[2.75rem] text-sm font-semibold underline-offset-2 hover:underline"
                onClick={() => setOpen(true)}
              >
                Passer à l’accès complet
              </button>
            ))}
        </>
      )}
    </div>
  );
}
